var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYouTubePlaylistThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3016 12.0758C26.3016 12.0758 26.0968 10.7085 25.4694 10.1064C24.7513 9.39322 23.9548 9.32032 23.5056 9.27921C23.4568 9.27474 23.4121 9.27065 23.372 9.26615C20.4425 9.06524 16.0481 9.06525 16.0481 9.06525H16.039C16.039 9.06525 11.6446 9.06524 8.71508 9.26615C8.67502 9.27064 8.63036 9.27473 8.58161 9.27919C8.13202 9.3203 7.33592 9.3931 6.61702 10.1064C5.98964 10.7085 5.78552 12.0758 5.78552 12.0758C5.78552 12.0758 5.57617 13.6819 5.57617 15.2873V16.7929C5.57617 18.3989 5.78552 20.0044 5.78552 20.0044C5.78552 20.0044 5.98964 21.3717 6.61702 21.9738C7.27811 22.6297 8.11075 22.7244 8.64126 22.7847C8.75019 22.7971 8.84638 22.808 8.92573 22.8221C10.6005 22.9746 16.0436 23.0218 16.0436 23.0218C16.0436 23.0218 20.4425 23.0155 23.372 22.8146C23.4125 22.81 23.4578 22.8058 23.5072 22.8013C23.9568 22.7597 24.7521 22.6861 25.4694 21.9738C26.0968 21.3717 26.3016 20.0044 26.3016 20.0044C26.3016 20.0044 26.5109 18.3989 26.5109 16.7929V15.2873C26.5109 13.6819 26.3016 12.0758 26.3016 12.0758ZM13.9509 19.6695L20.2314 16.0435L13.9509 12.4175V19.6695Z",
    fill: "white"
  })));
}

export default SvgYouTubePlaylistThumb;